var $25aa99fdd3227299$exports = {};
document.addEventListener("DOMContentLoaded", function onDdocLoaded() {
    document.removeEventListener("DOMContentLoaded", onDdocLoaded);
    const ctnr = document.getElementById("focus-section");
    if (!ctnr) return;
    new $25aa99fdd3227299$var$HScrollAnimation(ctnr);
});
class $25aa99fdd3227299$var$HScrollAnimation {
    constructor(ctnr){
        this.ctnr = ctnr;
        this.animatedEles = [];
        this.pstg = -1;
        this.initAnimatedEles();
        this.initEventListener();
        this.calcTopDistanceParams();
        this.checkAndAnimate();
    }
    initAnimatedEles() {
        this.animatedEles = [];
        this.ctnr.querySelectorAll("[data-a-s][data-a-e]").forEach((node)=>{
            const ele = node;
            const { aS: aS, aE: aE } = ele.dataset;
            const start = parseFloat(aS);
            const totalDistance = parseFloat(aE) - start;
            this.animatedEles.push({
                ele: ele,
                start: start,
                totalDistance: totalDistance
            });
        });
    }
    initEventListener() {
        document.addEventListener("scroll", ()=>{
            this.checkAndAnimate();
        });
        window.addEventListener("resize", ()=>{
            this.calcTopDistanceParams();
            this.checkAndAnimate();
        });
    }
    checkAndAnimate() {
        const pstg = this.getAnimatePstg();
        if (pstg === this.pstg) return;
        if (this.rafHandle) cancelAnimationFrame(this.rafHandle);
        this.rafHandle = requestAnimationFrame(()=>{
            this.pstg = pstg;
            this.doAnimate();
        });
    }
    calcTopDistanceParams() {
        const ctnrRect = this.ctnr.getBoundingClientRect();
        const startPos = ctnrRect.top + document.documentElement.scrollTop - window.innerHeight;
        const totalDist = ctnrRect.height + window.innerHeight;
        this.distParams = {
            startPos: startPos,
            totalDist: totalDist
        };
    }
    getAnimatePstg() {
        const topDis = document.documentElement.scrollTop - this.distParams.startPos;
        if (topDis < 0) return 0;
        const pstg = topDis / this.distParams.totalDist;
        if (pstg > 1) return 1;
        return pstg;
    }
    doAnimate() {
        this.animatedEles.forEach((ele)=>{
            ele.ele.style.transform = `translate3d(${ele.start + this.pstg * ele.totalDistance}${window.innerWidth >= window.innerHeight ? "vw" : "vh"}, 0, 0)`;
        });
    }
}


//# sourceMappingURL=mcllp.a145ec98.js.map
